import React from "react";
import { STEPS } from "./StrategyCanvasHelpers";

// Renders the step-by-step timeline shown inside each SME row's accordion
// body. Kept as its own component so StrategyCanvas.js stays focused on the
// row/list rendering.
const StrategyCanvasSteps = ({ filled, stepDates = [] }) => {
  return (
    <div className="scm-steps">
      {STEPS.map((label, index) => {
        const stepNumber = index + 1;
        const isDone = stepNumber <= filled;
        const isCurrent = stepNumber === filled;
        return (
          <div
            className={`scm-step-row ${isDone ? "done" : ""} ${
              isCurrent ? "current" : ""
            }`}
            key={label}
          >
            <div className="scm-step-number">Step {stepNumber}</div>
            <div className="scm-step-icon">
              {isDone ? (
                <img src="/assets/images/true-sucess.svg" alt="" />
              ) : (
                "–"
              )}
            </div>
            <div className="scm-step-label">{label}</div>
            <div className="scm-step-date">
              {isDone ? stepDates[index] || "-" : "-"}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StrategyCanvasSteps;
